import { DriftEnv } from '@drift-labs/sdk';
import { EnvironmentConstants } from '@drift/common';
import Env from 'src/environmentVariables/EnvironmentVariables';

export const getRpcOptions = (driftEnv: DriftEnv) => {
	return (
		driftEnv === 'devnet'
			? EnvironmentConstants.rpcs.dev
			: EnvironmentConstants.rpcs.mainnet
	).filter((rpcOption) => !Env.rpcsToExclude?.includes(rpcOption.value));
};
